import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const ModalWindowBody = props => {
  const { className, children, ...other } = props;

  return (
    <div className={clsx("em-c-modal__body", className)} {...other}>
      {children}
    </div>
  );
};

ModalWindowBody.propTypes = {
  /** Additional css classNames to append to the outer element */
  className: PropTypes.string,
  /** React component children */
  children: PropTypes.node
};

ModalWindowBody.defaultProps = {
  className: "",
  children: null
};

export default ModalWindowBody;
